document.addEventListener('DOMContentLoaded', () => {
  const notifier = document.querySelector('.cookie-notification');
  if (notifier) {
    notifier.querySelector('button').addEventListener('click', () => {
      window.localStorage.setItem('cookie-notification', notifier.getAttribute('data-updated'));
      notifier.querySelector('.cookie-notification_content').addEventListener('transitionend', (evt) => {
        if (evt.propertyName == 'transform') {
          notifier.remove();
        }
      });
      notifier.classList.remove('active');
    });

    const status = window.localStorage.getItem('cookie-notification');
    if (!status || (new Date(status)) < new Date(notifier.getAttribute('data-updated'))) {
      notifier.classList.add('active');
    } else {
      notifier.remove();
    }
  }
})